import { useMutation } from '@tanstack/react-query';
import { showResult } from 'infrastructure/hooks/utils';

import { updatePatientStatusFn } from './api';
import { useUpdatePatientInfoCache } from '../patient/use-update-patient-info-cache';

export const useUpdatePatientStatus = () => {
  const { updateCache } = useUpdatePatientInfoCache();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: updatePatientStatusFn,
    onSuccess(data, variables) {
      updateCache(variables.patientGuid, {
        status: variables.status,
      });
      showResult();
    },
  });

  return { updateStatus: mutateAsync, statusLoading: isLoading };
};
